import React, { useEffect, useRef, useState } from "react";
import { ReactComponent as HomeIcon } from "../../../assets/icons/HomeIcon.svg";
import { ReactComponent as PatientsIcon } from "../../../assets/icons/PatientsIcon.svg";
import { ReactComponent as ClassEnrollments } from "../../../assets/icons/ClassEnrollments.svg";
import { ReactComponent as ClinicianList } from "../../../assets/icons/ClinicianList.svg";
import { ReactComponent as OverdueInvoices } from "../../../assets/icons/OverdueInvoices.svg";
import { ReactComponent as PatientList } from "../../../assets/icons/PatientList.svg";
import { ReactComponent as Reports } from "../../../assets/icons/reports.svg";
import { ReactComponent as Revenue } from "../../../assets/icons/Revenue.svg";
import { ReactComponent as TestAccounts } from "../../../assets/icons/TestAccounts.svg";
import { ReactComponent as Utilization } from "../../../assets/icons/Utilization.svg";
import { ReactComponent as MixPanelLogo } from "../../../assets/icons/MixPanelLogo.svg";
import { ReactComponent as StripeLogo } from "../../../assets/icons/StripeLogo.svg";
import { ReactComponent as LogoutIcon } from "../../../assets/icons/LogoutIcon.svg";

import MenuItem, { MiniMenuItem, ThirdPartyMenuItem } from "./MenuItems";

const OPSMenu = ({ path, handleLogout }) => {
  const reportsSubmenu = useRef();
  const [reportsToggle, setReportsToggle] = useState(false);

  useEffect(() => {
    if (reportsToggle) {
      reportsSubmenu.current.style.display = "block";
    } else {
      reportsSubmenu.current.style.display = "none";
    }
  }, [reportsToggle]);
  return (
    <div
      className="container-fluid sidebar-menu-container"
      style={{ position: "relative", height: "65%" }}
    >
      <div style={{ height: "2vh" }} />
      <div
        style={{
          height: "50vh",
          overflowY: "scroll",
        }}
      >
        <MenuItem
          href={"/ops/home"}
          text={"Home"}
          selected={path.includes("home")}
        >
          <HomeIcon />
        </MenuItem>
        <MenuItem
          icon={PatientsIcon}
          href={"/ops/clinics/all/"}
          text={"All Clinics"}
          selected={path.includes("clinics") && !path.includes("test")}
        >
          <PatientsIcon />
        </MenuItem>
        <MenuItem
          icon={Reports}
          href={"#"}
          text={"Reports"}
          selected={false}
          onClick={() => {
            setReportsToggle(!reportsToggle);
          }}
          collapsible
        >
          <Reports />
        </MenuItem>
        <div
          className="container px-4"
          id="reportsSubmenu"
          ref={reportsSubmenu}
          style={{ display: "none" }}
        >
          <MiniMenuItem
            icon={Utilization}
            href={"/ops/reports/utilization/"}
            text={"Utilization"}
            selected={path.includes("utilization")}
          >
            <Utilization />
          </MiniMenuItem>
          <MiniMenuItem
            icon={Revenue}
            href={"/ops/reports/revenue/"}
            text={"Revenue"}
            selected={path.includes("revenue")}
          >
            <Revenue />
          </MiniMenuItem>
          <MiniMenuItem
            icon={OverdueInvoices}
            href={"/ops/reports/overdue-invoices/"}
            text={"Overdue Invoices"}
            selected={path.includes("overdue")}
          >
            <OverdueInvoices />
          </MiniMenuItem>
          <MiniMenuItem
            icon={PatientList}
            href={"/ops/reports/patients/"}
            text={"Patient List"}
            selected={path.includes("patients")}
          >
            <PatientList />
          </MiniMenuItem>
          <MiniMenuItem
            icon={ClinicianList}
            href={"/ops/reports/clinicians/"}
            text={"Clinician List"}
            selected={path.includes("clinicians")}
          >
            <ClinicianList />
          </MiniMenuItem>
        </div>
        <MenuItem
          icon={TestAccounts}
          href={"/ops/clinics/test/"}
          text={"Test Accounts"}
          selected={path.includes("test")}
        >
          <TestAccounts />
        </MenuItem>
        <MenuItem
          icon={ClassEnrollments}
          href={"/ops/class-enrollments/"}
          text={"Class Enrollments"}
          selected={path.includes("enrollments")}
        >
          <ClassEnrollments />
        </MenuItem>
        <div style={{ height: "2vh" }} />
        <ThirdPartyMenuItem
          icon={MixPanelLogo}
          href={`https://mixpanel.com/project/${process.env.REACT_APP_MIXPANEL_ID}/`}
          text={"MixPanel Dashboard"}
          selected={path.includes("mix-panel")}
        >
          <MixPanelLogo />
        </ThirdPartyMenuItem>
        <ThirdPartyMenuItem
          icon={StripeLogo}
          href={"https://dashboard.stripe.com/dashboard"}
          text={"Stripe Dashboard"}
          selected={path.includes("stripe")}
        >
          <StripeLogo />
        </ThirdPartyMenuItem>
      </div>
      <hr style={{ color: "white", height: "2px", opacity: "100" }} />
      <div
        style={{
          position: "absolute",
          bottom: "2vh",
          width: "100%",
          padding: "0px",
          margin: "0px",
        }}
      >
        <MenuItem
          icon={LogoutIcon}
          onClick={handleLogout}
          href={""}
          text={"Logout"}
        >
          <LogoutIcon />
        </MenuItem>
      </div>
    </div>
  );
};

export default OPSMenu;
